<template>
  <div class="boss">
    <div class="reading">
      <div v-if="safari == false">
        <div
          style="
            height: 136px;
            overflow: hidden;
            width: 100%;
            background-size: 100%;
            background-image: url(http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/06/1622700970029.png);
            background-repeat: no-repeat;
          "
        >
          <div
            style="
              text-align: center;

              color: white;
            "
          >
            <p style="font-size: 16px; padding-top: 32px">考试名称：</p>
            <div style="font-size: 18px; padding-top: 20px; line-height: 30px">
              {{ exam_name }}
            </div>
          </div>
        </div>
        <div class="reading-main">
          <div class="reading-detail" v-if="timelimit == true">
            <div style="margin-top: 40px; color: #999999; font-size: 16px">
              考试时间:
            </div>
            <div style="margin-top: 16px; font-size: 18px">
              {{ begin_time }}
            </div>

            <div style="margin-top: 12px; color: #999999; font-size: 16px">
              至
            </div>

            <div style="margin-top: 12px; font-size: 18px">{{ end_time }}</div>
          </div>
          <div class="reading-name">
            <div
              style="
                font-size: 16px;
                margin-top: 24px;
                color: #999999;
                padding-top: 24px;
              "
            >
              考生姓名:
            </div>
            <div
              style="
                font-size: 24px;
                font-weight: bold;
                color: black;
                margin-top: 24px;
              "
            >
              {{ student_name }}
            </div>
          </div>
          <div class="reading-footer">
            <van-button @click="exam_start">
              {{ "进入监控" }}
            </van-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="safari == true">
      <div
       style="
          float: right;
          margin-right: 10px;
          width: 222px;
          height: 80px;
          background-image: url(http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/06/1622703258379.png);
        "
      >
        <div style="padding-top: 19px; padding-left: 16px; color: gray">
          为保证考试效果，点击右上角，选择在
          <img
            src="../../../assets/images/exam_live/safari_icon.png"
            style="width: 25px; height: 25px"
          />
          打开
        </div>
      </div>

      <div style="margin-top: 400px">
        <img
          src="../../../assets/images/exam_live/safari.png"
          style="width: 375px; height: 200px"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LiveExam",
  data() {
    return {
      contaArray: [],
      exam_name: "",
      begin_time: "",
      end_time: "",
      student_name: "",
      stopClickLogin: false,
      maxtime: 5,
      Check: false,
      readingtext: "考试时间",
      radio: false,
      userPaperId: null,
      weixin: false,
      ios: false,
      safari: false,
      timelimit: true,
    };
  },
  beforeCreate() {
    // 修改背景色
    document
      .querySelector("body")
      .setAttribute("style", "background-color: #f5f6fa;padding: 15px;");
  },
  beforeDestroy() {
    // 销毁背景色
    document.querySelector("body").removeAttribute("style");
  },
  mounted() {},
  methods: {
    isIOS() {
      // 判断是iOS 还是安卓
      let u = navigator.userAgent;
      let app = navigator.appVersion;
      // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        this.ios = true;
      }
    },
    WeiXin() {
      // 判断是否是微信内置浏览器
      let isWeiXin = () => {
        return (
          navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
        );
      };
      if (isWeiXin()) {
        this.weixin = true;
      }
    },
    exam_start() {
      sessionStorage.setItem("channel", 2);
      sessionStorage.setItem("tasktype", this.contaArray[1]);
      sessionStorage.setItem("examid", this.contaArray[0]);
      sessionStorage.setItem("businessid", this.contaArray[2]);

      this.$router.push("/exam_live");
    },
    goPhoneExam() {
      console.log("执行zxc");
    },
  },
  async created() {
    this.isIOS();
    this.WeiXin();
    if (this.weixin == true && this.ios == true) this.safari = true;
    localStorage.setItem("organ", "");
    localStorage.setItem("actor", "");
    localStorage.setItem("token", "");
    localStorage.setItem("branch", "");
    localStorage.setItem("tokens", this.$route.query.tokens);

    let pa = { token: this.$route.query.tokens };

    var container;
    await this.$api.exam_live.getInfo(pa).then((res) => {
      if (res.message == "success") {
        container = res.data;
      }
    });
    let flag = 0;
    for (let i = 0; i < container.length; i++) {
      if (container[i] == "&") {
        if (flag == 0) {
          this.contaArray.push(container.substring(flag, i));
        } else this.contaArray.push(container.substring(flag + 2, i));
        flag = i;
      }
    }
    this.contaArray.push(container.substring(flag + 2, container.length));
    localStorage.setItem("organ", this.contaArray[3]);
    localStorage.setItem("actor", this.contaArray[4]);
    localStorage.setItem("token", this.contaArray[5]);
    localStorage.setItem("branch", this.contaArray[6]);
    sessionStorage.setItem("userpaperid", this.contaArray[7]);

    await this.$api.exam_live
      .getExam({ id: this.contaArray[0] })
      .then((res1) => {
        if (res1.message == "success") {
          container = res1.data;
          this.exam_name = container.name;
          sessionStorage.setItem("examname", this.exam_name);

          this.student_name = container.userName;
          this.begin_time = container.startTime;
          this.end_time = container.endTime;
          if (container.isLimitTime == 0) this.timelimit = false;
        }
      });
  },
};
</script>
<style lang='stylus'>
#wdc-app {
  border-radius: 12px;
}

.boss {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
}

body {
  background-color: #f5f6fa;
}

.reading {
  &-detail {
    text-align: center;
    margin-top: 40px;
  }

  .van-button {
    width: 100%;
    height: 44px;
    border-radius: 25px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    background-color: #316fff;
    color: #ffffff;
    line-height: 22px;
    margin-top: 50px;
  }

  &-name {
    border-radius: 8px;
    text-align: center;
    height: 200px;
    background-color: #F5F6FA;
    margin-top: 100px;
  }

  &-main {
    margin: 30px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 25px;
  }

  &-title {
    text-align: center;
    z-index: 1;

    .d {
      z-index: 4;
    }
  }
}
</style>